import { signalStore, withState } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { withSelectedEntity } from '../../../shared/store/selected-entity.feature';
import { TechniqueAnimation } from '../model/technique-animation.model';
import { avecMéthodesTechniquesAnimation } from './technique-animation.methods';
import { withPagination } from '../../../shared/store/pagination.feature';
import { initialState, TechniqueAnimationState } from './technique-animation.state';

export const TechniqueAnimationStore = signalStore(
  { providedIn: 'root' },
  withState<TechniqueAnimationState>(initialState),
  withEntities<TechniqueAnimation>(),
  withSelectedEntity(),
  avecMéthodesTechniquesAnimation(),
  withPagination<TechniqueAnimation>(),
);
